
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useHistoryTracker.html",
      function () {
        return require("private-next-pages/Hooks/useHistoryTracker.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useHistoryTracker.html"])
      });
    }
  